import { __decorate } from "tslib";
import { Addon, ApiConfig } from '../../limitPrivateAPI';
import { PrivateAPINamespace } from '../PrivateAPINamespace';
let AccessibilityNamespace = class AccessibilityNamespace extends PrivateAPINamespace {
    // @IsPlatformSDKProxyCall('DM')
    async getSkipToContent() {
        return this.ps.ds.accessibility.skipToContent.get();
    }
    // @IsPlatformSDKProxyCall('DM')
    async setSkipToContent(appDefinitionId, value) {
        this.ps.ds.runInContext(appDefinitionId, () => this.ps.ds.accessibility.skipToContent.set(value));
        await this.ps.ds.waitForChangesAppliedAsync();
    }
    // @IsPlatformSDKProxyCall('DM')
    async getVisualFocus() {
        return this.ps.ds.accessibility.visualFocus.get();
    }
    // @IsPlatformSDKProxyCall('DM')
    async setVisualFocus(appDefinitionId, value) {
        this.ps.ds.runInContext(appDefinitionId, () => this.ps.ds.accessibility.visualFocus.set(value));
        await this.ps.ds.waitForChangesAppliedAsync();
    }
    // @IsPlatformSDKProxyCall('DM')
    async getAutoDomReorder() {
        return this.ps.ds.accessibility.autoDomReorder.get();
    }
    // @IsPlatformSDKProxyCall('DM')
    async setAutoDomReorder(appDefinitionId, value) {
        this.ps.ds.runInContext(appDefinitionId, () => this.ps.ds.accessibility.autoDomReorder.set(value));
        await this.ps.ds.waitForChangesAppliedAsync();
    }
    // @IsPlatformSDKProxyCall('DM')
    getAdvancedSettings() {
        return this.ps.hostAPI.accessibility.getAdvancedSettings();
    }
    // @IsPlatformSDKProxyCall('DM')
    setAdvancedSettings(value) {
        return this.ps.hostAPI.accessibility.setAdvancedSettings(value);
    }
};
AccessibilityNamespace.namespace = 'accessibility';
AccessibilityNamespace = __decorate([
    ApiConfig(Addon)
], AccessibilityNamespace);
export { AccessibilityNamespace };
//# sourceMappingURL=AccessibilityNamespace.js.map